import { Collapse, List } from '@farol-ds/react'
import classNames from 'classnames'

import { MAX_VISIBLE_SUBJECTS } from '../../constants'
import { SubjectProps } from '../../types'
import { SubjectItem } from '../subject-item'
import subjectsStyles from '../subjects.module.scss'
import styles from './collapsed-subjects.module.scss'

export type CollapsedSubjectsProps = {
  subjects: SubjectProps[]
}

export function CollapsedSubjects(props: CollapsedSubjectsProps) {
  const { subjects } = props

  const collapsedSubjects = {
    visible: subjects.slice(0, MAX_VISIBLE_SUBJECTS),
    collapsed: subjects.slice(MAX_VISIBLE_SUBJECTS),
  }

  return (
    <Collapse>
      <List className={subjectsStyles.list}>
        {collapsedSubjects.visible.map((subject, index) => (
          <SubjectItem subject={subject.name} key={index} />
        ))}
      </List>

      {collapsedSubjects.collapsed.length > 0 && (
        <Collapse.Content className={classNames(subjectsStyles.list, styles.unstyledList)}>
          {collapsedSubjects.collapsed.map((subject, index) => (
            <SubjectItem subject={subject.name} key={index} />
          ))}
        </Collapse.Content>
      )}
    </Collapse>
  )
}
